import { Tag, TagI } from "constructs/Tag";
import { api } from "services/api";
// import { GetProjectArgs, ProjectResult, ProjectSlug } from "./typing";
// import { transformProjectResult } from "./transformers";
import { generateParams } from "utils/urlConversion";
import { TagSearchArgs, TagUploadBulkArgs } from "./typing";


const projectApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // getProjectById: builder.query<ProjectResult, GetProjectArgs>({
    //   query: (args) => {
    //     return `/project/${args.id}`;
    //   },
    //   transformResponse(result: ProjectResult, meta, args) {
    //     return transformProjectResult(result);
    //   }
    // }),

    // getAllProjects: builder.query<Array<ProjectSlug>, void>({
    //   query: (args) => `/projects/list`
    // }),

    // getAllProjectIds: builder.query<Array<ProjectSlug>, void>({
    //   query: (args) => `/projects/list/ids`
    // }),

    getTagsByName: builder.query<Array<TagI>, TagSearchArgs>({
      query: (args: TagSearchArgs) => {
        const { name, ...params } = args;

        // console.log(Object.keys(params));
        // console.log(params);
        // console.log("" + new URLSearchParams(params as any));


        return `/tags/search/${name}` + generateParams(params);
      }
    }),


    addTags: builder.mutation<any, TagUploadBulkArgs>({
      query: (args: TagUploadBulkArgs) => {

        const { useBulkUpload, tags, bulkStr, ...params} = args;
        const request = {
          url: `tags/create` + generateParams(params),
          method: 'POST',
          body: {}
        }

        if (useBulkUpload) {
          if (!bulkStr || bulkStr === "" || bulkStr === "{}" || bulkStr === "[]") {
            // Don't let users upload empty json
            throw new Error("Bulk JSON string cannot be undefined or empty string.");
          }
          
          request.body = JSON.stringify({ bulkStr })
          console.log(request.body);
          return request;
        }

        if (!tags || tags.length === 0) {
          // Don't let users attempt to upload empty tags
          throw new Error("You must upload at least one tag.")
        }

        // Add the tags to the JSON body and return built request
        request.body = JSON.stringify({ tags });
        return request;
      }
    })

  })

});



export const {
  useGetTagsByNameQuery,
  useLazyGetTagsByNameQuery,

  useAddTagsMutation,


} = projectApi;